export const loadScript = (src, onScriptLoaded) => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      //   onScriptLoaded(true);
      resolve(true);
    };
    script.onerror = () => {
      //   onScriptLoaded(false);
      resolve(false);
    };
    document.body.appendChild(script);
  });
};
